import PropTypes from "prop-types"
import { Flex, Tooltip } from "antd"
import { useTranslation } from "react-i18next"
import { CheckCircleFilled, InfoCircleOutlined } from "@ant-design/icons"
import styles from "./index.module.css"

const WaiverStatus = ({ isWaiverAttached, totalGuestCount, signedWaiverCount }) => {
  const { t } = useTranslation()

  if (!isWaiverAttached || !totalGuestCount) return null

  const isAllSigned = signedWaiverCount === totalGuestCount

  if (isAllSigned) {
    return (
      <Flex gap={4} align="center" className={styles.signed}>
        <CheckCircleFilled />
        <span>{t("bookings.waiver.signed")}</span>
      </Flex>
    )
  }

  const missingCount = totalGuestCount - signedWaiverCount

  return (
    <Flex gap={4} align="center" className={styles.missing}>
      <Tooltip title={t("bookings.waiver.tooltip", { signed: signedWaiverCount, total: totalGuestCount })}>
        <InfoCircleOutlined onClick={(e) => e.stopPropagation()} />
      </Tooltip>
      <span>
        {t("bookings.waiver.missing", { count: missingCount })}
      </span>
    </Flex>
  )
}

WaiverStatus.propTypes = {
  isWaiverAttached: PropTypes.bool,
  totalGuestCount: PropTypes.number,
  signedWaiverCount: PropTypes.number
}

export default WaiverStatus
